import { useTranslation } from "react-i18next";
import RoleManagementPage from "./RoleManagementPage";
import {
  ADMIN_ORGANIZATIONS,
  ADMIN_ORGANIZATION_REQUESTS,
  REJECT_ORGANIZATION,
} from "@/api/services/adminservice";

export default function Organisation() {
  const { t } = useTranslation();
  return (
    <RoleManagementPage
      entityLabel={t('admin.organisation.entityLabel', 'Organisation')}
      totalLabel={t('admin.organisation.totalLabel', 'Total Organisations')}
      requestLabel={t('admin.organisation.requestLabel', 'Operator Requests')}
      requestDescription={t('admin.organisation.requestDescription', 'Operators who have requested to become organisations.')}
      searchPlaceholder={t('admin.organisation.searchPlaceholder', 'Search organisations or requests...')}
      inviteRole="organization"
      entityDescription={t('admin.organisation.entityDescription', 'All organisations fetched from the admin organisations list.')}
      ownerColumnLabel={t('admin.organisation.ownerColumnLabel', 'Owner Name')}
      dateColumnLabel={t('admin.organisation.dateColumnLabel', 'Became Organisation At')}
      emptyEntitiesLabel={t('admin.organisation.emptyEntitiesLabel', 'No organisations found.')}
      emptyRequestsLabel={t('admin.organisation.emptyRequestsLabel', 'No operator organisation requests found.')}
      themeKey="organisation"
      entityIcon="building"
      listEntities={ADMIN_ORGANIZATIONS}
      listRequests={ADMIN_ORGANIZATION_REQUESTS}
      rejectEntity={REJECT_ORGANIZATION}
    />
  );
}
